<template>
  <v-content class="grey lighten-4">
    <v-container
      class="px-0 d-flex align-center justify-center mt-8"
      style="flex-direction: column;"
    >
      <div>
        <v-icon size="24" class="mr-2">mdi-information-outline</v-icon>
        <span class="grey--text text--darken-1"
          >Inget giltigt distrikt hittades</span
        >
      </div>
      <v-btn class="mt-8" tile @click="onLogout">
        <v-icon small left>mdi-exit-to-app</v-icon>
        Logga ut
      </v-btn>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'NoDistrict',

  methods: {
    onLogout() {
      this.$sso.logout()
    }
  }
}
</script>
